import * as Globals from "../../globals";
import {roomGroup} from "../../main";
import {Box3, Euler, Vector3} from "three";
import {showMessage} from "../../../ui/ui";
import {t} from "../../../i18n";
import {toFixedFloat} from "../../utils/utils";
import * as SceneManager from "../../sceneManager";
import {clearGroup, layoutCamera, render} from "../../sceneManager";
import {disableLayer, enableLayerById, setObjectLayer} from "../../utils/layerUtils";
import {Text} from "../baseElements/text";
import {TransactionManager} from "../../TransactionManager";
import {getRooms} from "./roomDetection/roomDetection";
import {createPathFromPoints} from "../../utils/shapeUtils";
import polylabel from 'polylabel';

export async function createRooms() {
    let roomMeshes = getRooms();

    try {
        if (roomGroup.parent === null) {
            SceneManager.scene.addWithUuid(roomGroup);
        }

        // clearGroup(roomNamesGroup);

        //Prüfen, ob bereits Räume angelegt wurden. Wenn ja, werden diese später gematcht wieder
        let oldGroupData = [];
        if (roomGroup.children.length > 0) {
            for (let i = 0; i < roomGroup.children.length; i++) {
                oldGroupData.push({...roomGroup.children[i].userData});
            }
        }
        clearGroup(roomGroup);


        let totalArea = 0;
        for (let i = 0; i < roomMeshes.length; i++) {
            let roomMesh = roomMeshes[i];
            totalArea += roomMesh.userData.area;

            if (oldGroupData.length === 0) {
                roomMesh.userData.roomName = "Raum " + (i + 1);
            }
            roomMesh.name = "roomMesh";
            roomMesh.position.y += 0.01; //Über möglichen Boden Mesh positionieren für bessere Sichtbarkeit
            roomMesh.visible = false;
            roomGroup.addWithUuid(roomMesh);
        }

        setObjectLayer(roomGroup, Globals.layers.roomShapes, true);
        remapRoomNames(roomMeshes, oldGroupData);
        createRoomNames(roomMeshes);
        $('#living-area-value').text(totalArea.toFixed(2) + ' m²');
    } catch (e) {
        console.error(e);
    }
}

function remapRoomNames(meshes, oldGroupData) {
    if (oldGroupData.length > 0) {
        for (let i = 0; i < meshes.length; i++) {
            let newUserData = meshes[i].userData;
            let newPoints = newUserData.points;
            for (let j = 0; j < oldGroupData.length; j++) {
                let oldUserData = oldGroupData[j];
                let oldPoints = oldUserData.points;

                if (compareRoomPoints(oldPoints, newPoints)) {
                    meshes[i].userData.roomName = oldUserData.roomName !== undefined ? oldUserData.roomName : "Raum";
                    break;
                }

                meshes[i].userData.roomName = "Neuer Raum";
            }
        }
    }
}

function createRoomNames(meshes) {
    for (let i = 0; i < meshes.length; i++) {
        let mesh = meshes[i];
        createRoomName(mesh);
    }
}

function createRoomName(mesh) {
    let name = mesh.userData.roomName;
    let center = getPolyCenter(mesh);
    let roomText = name + "\n" + toFixedFloat(mesh.userData.area, 2) + "m²";
    //Center Koordinaten werden hie umgemappt, weil diese relativ zum Mesh sind, welcher hier nicht rotiert ist.
    let text = new Text(roomText, 0.125, 'center', -0.135, new Vector3(center.x, center.z, -0.02), new Euler(-Math.PI, 0, 0), null, 0x000000);
    setObjectLayer(text, Globals.layers.roomShapes);
    mesh.addWithUuid(text);
}
/*
    A fast algorithm for finding polygon pole of inaccessibility [x,y], 
    the most distant internal point from the polygon outline (not to be confused with centroid)
    @see https://github.com/mapbox/polylabel
*/
function getPolyCenter(room) {
    let path = createPathFromPoints(room.userData.points);
    let geoPolygon = [];
    path.getPoints().forEach(point => geoPolygon.push(point.toArray()));
    let polyCenter = polylabel([geoPolygon],0.1);
    return new Vector3(polyCenter[0], 0, polyCenter[1]);
}

export let currentRoom = null;

export function toggleRoomLabeling(active) {
    roomGroup.children.forEach((child) => {
        child.visible = active;
    });

    if (active) {
        enableLayerById(layoutCamera, Globals.layers.roomShapes);
        enableLayerById(layoutCamera, Globals.layers.roomNames);
    } else {
        disableLayer(layoutCamera, Globals.layers.roomShapes);
        disableLayer(layoutCamera, Globals.layers.roomNames);
    }
    render();
}

export function setCurrentRoom(room) {
    currentRoom = room;
}

export function setCurrentRoomName(name) {
    if (currentRoom === null) {
        return;
    }
    if (currentRoom.name == 'wallGroup') {
        showMessage(t("select_room_area"), "Hinweis");
        return;
    }
    TransactionManager.startTransaction();
    clearGroup(currentRoom);
    currentRoom.userData.roomName = name;
    createRoomName(currentRoom);
    TransactionManager.stopTransaction();
    currentRoom = null;
    $('#roomType').val("");
}

//Utils
function compareRoomPoints(oldPoints, newPoints) {
    //Prüfen, ob die alten und neuen Punkte mindestens 2 Elemente teilen. Dann handelt es sich um denselben Raum, oder einen Raum, der aus diesem entstanden ist.
    return oldPoints.filter(oldPoint => newPoints.some(newPoint => oldPoint.equals(newPoint))).length >= 2;
}

export function clearRoomState() {
    //Als default werden alle Raumelemente ausgeblendet. Werden nur angezeigt, wenn die Raumansicht per UI aktiviert wird.
    roomGroup.children.forEach((child) => {
        child.visible = false;
    });
}

export function changeRoomName(e, room) {
    let mouseX = e.pageX;
    let mouseY = e.pageY;
    if (room === null || room === undefined) {
        return;
    }

    let name = room.userData.roomName ?? '';
    currentRoom = room;

    $('#label-room-input-container').css({'top': mouseY, 'left': mouseX}).addClass('d-flex').removeClass('d-none');
    $('#label-room-input').val(name.toString()).focus().select();
}

export function hideRoomNameInput() {
    $('#label-room-input-container').addClass('d-none').removeClass('d-flex');
    $('#label-room-input').val("");
    currentRoom = null;
}

export function applyRoomName(name) {
    if (currentRoom !== null) {
        setCurrentRoomName(name);
        hideRoomNameInput();
    }
}
